import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_staff/accesses/_layout/')({
  beforeLoad: ({ location }) => {
    const newPathname = '/accesses/list';

    const searchParams = new URLSearchParams(location.search);
    const search = searchParams.toString();
    const to = search ? `${newPathname}?${search}` : newPathname;

    throw redirect({ to });
  },
});
